module.exports = __webpack_public_path__ + "img/pic-5-2.d39b4bf0.png";